<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="47.9968mm"
    height="27.9478mm"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 1221.78 711.43"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <mask id="id0">
        <linearGradient
          id="id1"
          gradientUnits="userSpaceOnUse"
          x1="391.46"
          y1="626.15"
          x2="647.63"
          y2="18.95"
        >
          <stop offset="0" style="stop-opacity: 1; stop-color: white" />
          <stop offset="1" style="stop-opacity: 0; stop-color: white" />
        </linearGradient>
        <rect
          style="fill: url(#id1)"
          x="289.22"
          y="41.58"
          width="627.41"
          height="627.41"
        />
      </mask>
      <mask id="id2">
        <radialGradient
          id="id3"
          gradientUnits="userSpaceOnUse"
          cx="962.93"
          cy="277.32"
          r="0"
          fx="962.93"
          fy="277.32"
        >
          <stop offset="0" style="stop-opacity: 1; stop-color: white" />
          <stop offset="1" style="stop-opacity: 0; stop-color: white" />
        </radialGradient>
        <rect
          style="fill: url(#id3)"
          x="962.87"
          y="277.25"
          width="258.98"
          height="258.98"
        />
      </mask>
      <mask id="id4">
        <radialGradient
          id="id5"
          gradientUnits="userSpaceOnUse"
          cx="-998.41"
          cy="-804.46"
          r="286.95"
          fx="-998.41"
          fy="-804.46"
        >
          <stop offset="0" style="stop-opacity: 1; stop-color: white" />
          <stop
            offset="0.639216"
            style="stop-opacity: 0.501961; stop-color: white"
          />
          <stop offset="1" style="stop-opacity: 0; stop-color: white" />
        </radialGradient>
        <rect
          style="fill: url(#id5)"
          x="2.05"
          y="73.05"
          width="258.96"
          height="258.96"
        />
      </mask>
      <linearGradient
        id="id6"
        gradientUnits="objectBoundingBox"
        x1="49.9997%"
        y1="74.8799%"
        x2="50.0001%"
        y2="12.8004%"
      >
        <stop offset="0" style="stop-opacity: 1; stop-color: #81ad3d" />
        <stop offset="1" style="stop-opacity: 1; stop-color: #3aaa3d" />
      </linearGradient>
      <radialGradient
        id="id7"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-0.469049 -1.27686 -1.19741 0.49796 2082 1595)"
        cx="1092.36"
        cy="398.97"
        r="103.54"
        fx="1092.36"
        fy="398.97"
      >
        <stop offset="0" style="stop-opacity: 1; stop-color: #f59d3a" />
        <stop offset="0.0196078" style="stop-opacity: 1; stop-color: #f59d3a" />
        <stop offset="0.113725" style="stop-opacity: 1; stop-color: #f7c558" />
        <stop offset="0.941176" style="stop-opacity: 1; stop-color: #f8ed76" />
        <stop offset="1" style="stop-opacity: 1; stop-color: #f8ed76" />
      </radialGradient>
      <radialGradient
        id="id8"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-1.17905 0.621892 0.581911 1.25448 173 -131)"
        xlink:href="#id7"
        cx="131.53"
        cy="194.77"
        r="100.95"
        fx="131.53"
        fy="194.77"
      ></radialGradient>
      <radialGradient
        id="id9"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-1.17905 0.703411 0.658347 1.25415 153 -143)"
        cx="131.02"
        cy="200.51"
        r="73.63"
        fx="131.02"
        fy="200.51"
      >
        <stop offset="0" style="stop-opacity: 1; stop-color: #fef8fb" />
        <stop offset="0.45098" style="stop-opacity: 1; stop-color: #f8ed76" />
        <stop offset="0.792157" style="stop-opacity: 1; stop-color: #f6c558" />
        <stop offset="1" style="stop-opacity: 1; stop-color: #f59d3a" />
      </radialGradient>
      <radialGradient
        id="id10"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-0.55871 -1.31763 -1.23686 0.592547 2203 1604)"
        xlink:href="#id9"
        cx="1092.38"
        cy="404.24"
        r="73.64"
        fx="1092.38"
        fy="404.24"
      ></radialGradient>
    </defs>
    <g id="Camada_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M258.35 358.61c0,-189.12 154.53,-342.43 345.14,-342.43 190.61,0 345.14,153.31 345.14,342.43 0,189.13 -154.53,342.43 -345.14,342.43 -190.62,0 -345.14,-153.3 -345.14,-342.43z"
      />
      <path
        class="fil1"
        d="M603.72 24.58c-182.58,0 -331.13,148.55 -331.13,331.14 0,182.59 148.54,331.13 331.13,331.13 182.59,0 331.14,-148.54 331.14,-331.13 0,-182.59 -148.55,-331.14 -331.14,-331.14zm0 686.85c-196.14,0 -355.71,-159.57 -355.71,-355.71 0,-196.14 159.57,-355.72 355.71,-355.72 196.15,0 355.72,159.57 355.72,355.72 0,196.14 -159.58,355.71 -355.72,355.71z"
      />
      <path
        class="fil2"
        d="M289.28 355.29c0,173.22 140.42,313.64 313.65,313.64l0 0c173.21,0 313.64,-140.42 313.64,-313.64l0 0c0,-173.22 -140.43,-313.64 -313.64,-313.64 -173.22,0 -313.65,140.42 -313.65,313.64l0 0z"
      />
      <path
        class="fil2"
        style="mask: url(#id0)"
        d="M289.28 355.29c0,173.22 140.42,313.64 313.65,313.64l0 0c173.21,0 313.64,-140.42 313.64,-313.64l0 0c0,-173.22 -140.43,-313.64 -313.64,-313.64 -173.22,0 -313.65,140.42 -313.65,313.64l0 0z"
      />
      <path
        class="fil3"
        d="M520.8 380.94c0.12,0.19 0.24,0.28 0.28,0.62 0.05,0.43 0.43,1.03 0.51,1.26 0.33,0.99 0.54,2.03 0.81,2.74 1.15,2.95 0.68,2.62 3.66,3.43 1.04,-4.53 1.8,-34.06 1.75,-41.99 -0.06,-9.59 1.08,-10.62 3.89,-17.47 2.25,-5.48 4.8,-9.63 7.24,-14.95 4.79,-10.45 9,-20.8 10.96,-32.61 1.41,-8.44 1.41,-20.11 3.13,-28.96 0.68,-3.49 1.02,-5.98 2.87,-8.69 0,18.24 5.76,46.45 1.23,63.76l-3.49 10.73c-7.25,26.35 -8.13,44.61 -4.38,72.47 2.28,16.87 3.52,32.97 6.71,48.54 0.81,3.94 1.37,6.38 2.09,11.27 0.88,5.97 2.54,34.63 1.75,38.31 -0.82,3.79 -2.04,7.08 -2.88,10.47 -2.9,11.73 -1.07,25.03 1.6,36.46 4.54,19.44 17.12,49.88 12.06,68.54 -1.95,7.19 -6.32,12.28 -4.17,21.65l6.64 2.18c5.2,1.6 16.51,2.29 22.31,2.29 3.23,-4.9 2.82,-5.95 1,-12.63 -5.46,-20.13 -4.78,-24.15 -8.69,-42.06 -3.22,-14.79 1.43,-45.6 -0.23,-64.95 -1.86,-21.72 2.43,-39.84 5.44,-61.49 1.33,-9.61 2.58,-20.04 3.43,-30.44 0.88,-10.75 2.55,-20.09 2.55,-32.23l4.39 0 2.6 31.28c0.57,10.55 2.23,20.34 3.58,30.28 1.32,9.68 2.47,20.45 4.26,29.61 5.71,29.29 -0.98,31.77 0.99,61.5 0.73,10.94 2.6,20.06 1.02,31.46l-5.16 28.68c-1.71,12.43 -5.53,15.4 -5.53,29.2 4.7,1.28 4.17,2.72 12.96,0.84l8.94 -0.85c12.24,-1.96 11.87,-6.48 7.31,-18.13 -3.15,-8.04 -3.73,-17.39 -2.8,-26.42 2.58,-24.79 22.34,-59.75 13.39,-87.07 -3.1,-9.48 -2.82,-9.99 -2.15,-18.46l0.9 -22.3c0.21,-7.85 3.07,-17.76 4.3,-25.09 3.03,-17.99 4.26,-34.89 6.51,-53.22 5.53,-45.11 -13.82,-68.89 -10.42,-90.95l2.28 -43.25 3.16 7.5c5.28,27.85 -1.32,31.13 14.67,63.63 4.12,8.38 11.92,21.09 11.13,33.34 -0.47,7.24 -0.13,36.21 1.74,40.19 3.36,-2.29 2.99,-6.27 5.27,-8.94l1.76 15.18c6.94,-0.58 4.38,-13.58 4.38,-18.75 1.62,1.9 1.46,1.32 1.75,4.48 0.25,2.76 -0.01,3.79 0.48,6.65 0.69,4.16 0.46,8.04 4.79,8.52 1.96,-4.15 0.88,-13.04 0.88,-18.76 2.85,4.17 2.64,11.09 8.78,11.62 1.84,-8.06 -3.39,-18.61 -5.26,-26.8 2.77,2.07 2.74,4.5 5.11,6.52 3.17,2.69 6.13,2.03 5.32,-3.53 -2.06,-14.18 -18.9,-26.11 -21.36,-40.98 -3.08,-18.5 -1.43,-35.05 -8.74,-52.72 -20.58,-49.68 6.89,-108.66 -31.72,-116.84 -8.26,-1.75 -11.86,-1.66 -18.52,-5.26 -6.18,-3.34 -9,-6.53 -9.09,-15.76 -0.04,-4.64 -0.45,-8.05 1.17,-11.4 0.98,-2.03 1.41,-2.22 2.23,-3.96l3.63 -8.81c2.16,-3.41 7.52,-10.95 0.03,-11.59 0,-12.16 0.34,-18.84 -4.74,-26.42 -6.75,-10.07 -21.33,-15.57 -32.54,-9.74 -12.95,6.72 -15.59,15.57 -16.14,31.79 -0.23,6.81 -0.34,2.49 -1.86,5.29 -0.99,1.83 -0.46,-2.23 -0.91,2.67 -0.51,5.65 2.49,4.93 5.71,14.76 1.88,5.75 4.01,4.55 4.04,11.96 0.09,17.02 -2.92,22.04 -21.61,25.45 -10.43,1.9 -15.82,3.34 -20.93,10.84 -4.13,6.05 -7.31,14.03 -7.55,23.56 -0.74,29.01 2.54,59.05 -9.94,85.44 -3.3,6.98 -4.5,16.53 -4.95,26.21 -0.19,4.23 -1.2,10.21 -1.67,14.37 -3.31,29.28 -10.37,22.66 -19.9,44.05 -1.97,4.44 -3.23,7.23 -2.11,12.13 4.56,-0.1 5.79,-2.28 7.87,-5.38l1.78 -2.65c-0.57,7.04 -7.5,20.19 -4.39,26.8 3.58,-0.98 4.67,-4 6.12,-7.17l1.78 -3.55c0,6.68 -0.38,12.39 0.87,17.86 3.19,-0.26 2.56,0.28 3.72,-2.46 0.27,-0.63 0.96,-4.48 1.19,-5.93 0.7,-4.58 1.23,-7.38 1.23,-12.14l0.87 0c0,9.24 0.07,12.29 1.76,19.64 5.93,-0.49 5.26,-9.05 5.26,-14.28z"
      />
      <path
        class="fil0"
        d="M602.1 236.68c18.66,-0.23 33.71,-15.44 33.71,-34.14 0,-18.88 -15.29,-34.15 -34.15,-34.15 -0.16,0 -1.28,0.04 -1.33,0.05 -8.81,0.67 -15.75,8.04 -15.75,17.03 0,9.42 7.64,17.07 17.08,17.07 9.42,0 17.08,7.64 17.08,17.07 0,9.28 -7.42,16.84 -16.64,17.07zm-7.36 -17.07c0,3.82 3.1,6.91 6.92,6.91 3.82,0 6.91,-3.09 6.91,-6.91 0,-3.82 -3.09,-6.92 -6.91,-6.92 -3.82,0 -6.92,3.09 -6.92,6.92zm33.05 -43.21c-6.98,-6.99 -16.26,-10.83 -26.14,-10.83 -9.88,0 -19.17,3.84 -26.15,10.83 -6.98,6.99 -10.83,16.27 -10.83,26.14 0,9.87 3.85,19.15 10.83,26.14 6.98,6.98 16.26,10.83 26.15,10.83 9.87,0 19.15,-3.85 26.14,-10.83 6.98,-6.99 10.83,-16.26 10.83,-26.14 0,-9.88 -3.84,-19.16 -10.83,-26.14zm13.02 26.14c0,21.85 -17.73,39.59 -39.59,39.59 -21.87,0 -39.61,-17.74 -39.61,-39.59 0,-21.88 17.73,-39.61 39.61,-39.61 21.86,0 39.59,17.73 39.59,39.61z"
      />
      <path
        class="fil4"
        d="M608.57 186.48c0,3.82 -3.1,6.91 -6.92,6.91 -3.82,0 -6.92,-3.09 -6.92,-6.91 0,-3.81 3.1,-6.91 6.92,-6.91 3.82,0 6.92,3.1 6.92,6.91z"
      />
      <path
        class="fil0"
        d="M601.25 286.46l0 0c-64.67,0 -117.09,-52.43 -117.09,-117.1 0,-64.67 52.43,-117.09 117.09,-117.09 64.67,0 117.09,52.42 117.09,117.09 0,64.67 -52.42,117.1 -117.09,117.1zm0.83 -242.83c-73.51,0 -133.11,59.59 -133.11,133.11 0,73.51 59.59,133.1 133.11,133.1 73.51,0 133.11,-59.6 133.11,-133.1 0,-73.51 -59.59,-133.11 -133.11,-133.11z"
      />
      <path
        class="fil0"
        d="M602.92 461.29l0 0c-113.92,0 -206.26,-92.35 -206.26,-206.26 0,-113.9 92.34,-206.25 206.26,-206.25 113.91,0 206.26,92.35 206.26,206.25 0,113.91 -92.35,206.26 -206.26,206.26zm-1.69 -422.21c-125.21,0 -226.71,101.5 -226.71,226.7 0,125.21 101.5,226.72 226.71,226.72 125.2,0 226.7,-101.5 226.7,-226.72 0,-125.21 -101.5,-226.7 -226.7,-226.7z"
      />
      <path
        class="fil5"
        d="M946.06 259.22c1.52,5.28 2.98,10.75 4.31,16.26 129.61,18.47 212.8,47.06 212.8,79.16 0,55.7 -250.47,100.85 -559.44,100.85 -308.97,0 -559.43,-45.15 -559.43,-100.85 0,-32.14 83.42,-60.77 213.35,-79.24 1.09,-5.2 2.31,-10.63 3.67,-16.17 -157.85,21.04 -261.32,56.21 -261.32,96.05 0,64.41 270.3,116.62 603.73,116.62 333.43,0 603.73,-52.21 603.73,-116.62 0,-39.85 -103.51,-75.03 -261.4,-96.06z"
      />
      <path
        class="fil5"
        d="M875.96 126.82c3.57,4.17 7.17,8.55 10.67,13.01 125.6,-36.95 213.15,-45.44 226.46,-16.23 23.1,50.68 -186.08,195.65 -467.22,323.79 -281.14,128.15 -527.77,190.95 -550.87,140.27 -13.33,-29.25 50.7,-89.9 161.27,-160.59 -1.16,-5.18 -2.3,-10.63 -3.37,-16.24 -134.91,84.61 -214.47,159.53 -197.94,195.79 26.72,58.61 294.32,-5.99 597.72,-144.29 303.4,-138.29 527.7,-297.91 500.98,-356.52 -16.53,-36.26 -125.3,-25.34 -277.7,21.01z"
      />
      <path
        class="fil5"
        d="M330.42 126.82c-3.57,4.17 -7.17,8.55 -10.67,13.01 -125.6,-36.95 -213.15,-45.44 -226.46,-16.23 -23.1,50.68 186.08,195.65 467.22,323.79 281.14,128.15 527.77,190.95 550.87,140.27 13.33,-29.25 -50.7,-89.9 -161.27,-160.59 1.16,-5.18 2.3,-10.63 3.37,-16.24 134.91,84.61 214.48,159.53 197.95,195.79 -26.72,58.61 -294.32,-5.99 -597.72,-144.29 -303.4,-138.29 -527.7,-297.91 -500.98,-356.52 16.53,-36.26 125.3,-25.34 277.7,21.01z"
      />
      <path
        class="fil6"
        d="M1139.5 403.94c-8.94,4.29 -19.32,1.27 -23.17,-6.76 -3.85,-8.03 0.28,-18.01 9.22,-22.31 8.94,-4.29 19.32,-1.27 23.17,6.76 3.85,8.02 -0.27,18.01 -9.22,22.3z"
      />
      <path
        class="fil7"
        d="M1146.55 382.67c-3.27,-6.82 -12.23,-9.34 -19.96,-5.63 -7.74,3.71 -11.36,12.28 -8.09,19.1 3.27,6.82 12.23,9.34 19.96,5.63 7.74,-3.71 11.37,-12.28 8.09,-19.1zm-32.39 15.55c-4.42,-9.21 0.22,-20.66 10.35,-25.52 10.13,-4.86 21.96,-1.32 26.38,7.89 4.42,9.2 -0.22,20.65 -10.35,25.51 -10.12,4.86 -21.96,1.32 -26.38,-7.88z"
      />
      <path
        class="fil7"
        d="M1146.11 358.42c0,0 3.39,8.16 -3.54,14.86l3.54 -14.86z"
      />
      <path
        class="fil7"
        d="M1140.4 374.32c-0.44,-0.91 -0.27,-2.03 0.49,-2.77 5.62,-5.43 3.1,-11.95 2.99,-12.23 -0.49,-1.23 0.1,-2.63 1.33,-3.13 1.23,-0.5 2.62,0.07 3.13,1.3 0.17,0.4 3.92,9.76 -4.09,17.52 -0.96,0.92 -2.48,0.9 -3.4,-0.06 -0.19,-0.19 -0.33,-0.41 -0.44,-0.63z"
      />
      <path
        class="fil7"
        d="M1164.33 396.37c0,0 -4.25,-7.74 -13.81,-6.53l13.81 6.53z"
      />
      <path
        class="fil7"
        d="M1148.35 390.88c-0.11,-0.23 -0.18,-0.47 -0.22,-0.74 -0.17,-1.32 0.77,-2.52 2.08,-2.69 11.06,-1.4 16.02,7.39 16.22,7.76 0.64,1.16 0.22,2.63 -0.95,3.27 -1.16,0.64 -2.62,0.22 -3.26,-0.94 -0.16,-0.28 -3.68,-6.29 -11.41,-5.32 -1.05,0.13 -2.03,-0.44 -2.47,-1.34z"
      />
      <path
        class="fil8"
        style="mask: url(#id2)"
        d="M1041.01 287.98c-65.59,28.36 -95.78,104.52 -67.42,170.11l0 0c28.37,65.59 104.53,95.77 170.12,67.41l0 0c65.59,-28.36 95.78,-104.52 67.41,-170.12l0 0c-21.13,-48.85 -68.78,-78.07 -118.83,-78.07l0 0c-17.14,-0.01 -34.56,3.42 -51.29,10.66l0 0z"
      />
      <path
        class="fil9"
        d="M1079.82 376.16c-16.97,6.93 -25.11,26.32 -18.18,43.29l0 0c6.93,16.97 26.32,25.11 43.29,18.18l0 0c16.97,-6.94 25.11,-26.32 18.18,-43.29l0 0c-5.26,-12.87 -17.66,-20.65 -30.75,-20.65l0 0c-4.18,0 -8.43,0.79 -12.54,2.47l0 0z"
      />
      <path
        class="fil10"
        d="M1134.81 388.54c0,0 -11.62,-22 -35.78,-23.03 -16.59,-0.71 -31,8.02 -38.39,13.56 -2.79,2.08 -2.5,6.35 0.53,8.04 12.11,6.76 41.57,19 73.64,1.43z"
      />
      <path
        class="fil7"
        d="M1134.41 388.6c0,0 -6.01,-24.14 -29.21,-30.95 -15.93,-4.67 -32.02,0.35 -40.53,3.95 -3.2,1.36 -3.95,5.56 -1.41,7.93 10.14,9.46 35.8,28.42 71.15,19.07z"
      />
      <path
        class="fil10"
        d="M1134.2 387.34c0,0 8.05,23.54 -7.76,41.84 -10.85,12.57 -27.09,17.08 -36.19,18.66 -3.42,0.6 -6.33,-2.53 -5.49,-5.9 3.39,-13.45 14.66,-43.29 49.43,-54.6z"
      />
      <path
        class="fil7"
        d="M1133.88 387.58c0,0 13.46,20.92 2.52,42.48 -7.52,14.8 -22.19,23.08 -30.65,26.81 -3.18,1.41 -6.76,-0.93 -6.75,-4.41 0.06,-13.87 3.84,-45.55 34.88,-64.88z"
      />
      <path
        class="fil6"
        d="M124.66 155.81c5.05,8.54 2.94,19.13 -4.72,23.67 -7.66,4.53 -17.97,1.28 -23.02,-7.25 -5.06,-8.54 -2.94,-19.13 4.72,-23.66 7.66,-4.54 17.97,-1.29 23.02,7.25z"
      />
      <path
        class="fil7"
        d="M102.86 150.63c-6.51,3.85 -8.25,12.99 -3.88,20.37 4.37,7.38 13.22,10.25 19.73,6.41 6.51,-3.85 8.25,-12.99 3.88,-20.37 -4.37,-7.38 -13.22,-10.26 -19.73,-6.41zm18.29 30.92c-8.79,5.2 -20.59,1.57 -26.31,-8.09 -5.72,-9.67 -3.22,-21.76 5.57,-26.96 8.79,-5.21 20.59,-1.57 26.31,8.09 5.72,9.66 3.22,21.76 -5.57,26.96z"
      />
      <path
        class="fil7"
        d="M78.74 153.17c0,0 7.84,-4.08 15.12,2.24l-15.12 -2.24z"
      />
      <path
        class="fil7"
        d="M95.08 157.48c-0.87,0.51 -2,0.44 -2.8,-0.26 -5.9,-5.12 -12.18,-2.04 -12.44,-1.91 -1.18,0.6 -2.63,0.13 -3.23,-1.04 -0.6,-1.18 -0.15,-2.62 1.02,-3.23 0.38,-0.2 9.39,-4.75 17.81,2.56 1,0.87 1.11,2.39 0.24,3.39 -0.17,0.2 -0.37,0.37 -0.59,0.5z"
      />
      <path
        class="fil7"
        d="M114.97 131.73c0,0 -7.35,4.91 -5.31,14.32l5.31 -14.32z"
      />
      <path
        class="fil7"
        d="M110.88 148.12c-0.22,0.13 -0.46,0.23 -0.72,0.28 -1.3,0.28 -2.58,-0.54 -2.86,-1.84 -2.35,-10.89 5.97,-16.6 6.33,-16.83 1.1,-0.74 2.6,-0.44 3.33,0.66 0.74,1.1 0.45,2.59 -0.65,3.33 -0.27,0.19 -5.95,4.21 -4.31,11.82 0.22,1.04 -0.26,2.06 -1.13,2.58z"
      />
      <path
        class="fil11"
        style="mask: url(#id4)"
        d="M70.09 88.66c-62.89,33.93 -86.37,112.42 -52.43,175.31l0 0c33.93,62.89 112.42,86.36 175.31,52.43l0 0c62.89,-33.93 86.37,-112.43 52.43,-175.32l0 0c-23.38,-43.35 -67.95,-67.97 -113.98,-67.97l0 0c-20.75,-0 -41.79,5 -61.33,15.55l0 0z"
      />
      <path
        class="fil12"
        d="M116.51 172.97c-16.31,8.38 -22.74,28.39 -14.36,44.7l0 0c8.38,16.3 28.4,22.74 44.7,14.36l0 0c16.31,-8.39 22.74,-28.4 14.36,-44.71l0 0c-5.89,-11.46 -17.51,-18.04 -29.56,-18.04 -5.11,0 -10.29,1.18 -15.15,3.68l0 0z"
      />
      <path
        class="fil10"
        d="M109.72 161.81c0,0 -20.9,13.49 -19.84,37.65 0.73,16.59 10.67,30.19 16.83,37.08 2.32,2.59 6.54,1.94 7.96,-1.23 5.68,-12.65 15.33,-43.06 -4.95,-73.49z"
      />
      <path
        class="fil7"
        d="M109.83 162.21c0,0 -23.53,8.07 -28.3,31.78 -3.28,16.28 3.11,31.87 7.44,40.04 1.63,3.08 5.88,3.45 8.03,0.72 8.55,-10.92 25.22,-38.12 12.83,-72.53z"
      />
      <path
        class="fil10"
        d="M108.58 162.52c0,0 22.75,-10.05 42.36,4.11 13.46,9.72 19.36,25.5 21.73,34.44 0.89,3.36 -1.97,6.53 -5.4,5.97 -13.7,-2.2 -44.4,-10.85 -58.68,-44.52z"
      />
      <path
        class="fil7"
        d="M108.85 162.83c0,0 19.67,-15.22 42.1,-6.18 15.4,6.21 24.91,20.11 29.36,28.22 1.67,3.04 -0.34,6.81 -3.81,7.09 -13.82,1.15 -45.71,0.12 -67.65,-29.13z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "LogoIPM",
};
</script>

<style scoped>
* {
  width: 100%;
  height: auto;
}
.fil3 {
  fill: #242321;
}
.fil4 {
  fill: #2b2a29;
}
.fil0 {
  fill: #fefefe;
}
.fil1 {
  fill: #242321;
  fill-rule: nonzero;
}
.fil7 {
  fill: #2b2a29;
  fill-rule: nonzero;
}
.fil6 {
  fill: #ece313;
  fill-rule: nonzero;
}
.fil10 {
  fill: #fefefe;
  fill-rule: nonzero;
}
.fil5 {
  fill: #b3b3b3;
  fill-rule: nonzero;
  fill-opacity: 0.678431;
}
.fil2 {
  fill: url(#id6);
}
.fil8 {
  fill: url(#id7);
}
.fil11 {
  fill: url(#id8);
}
.fil12 {
  fill: url(#id9);
}
.fil9 {
  fill: url(#id10);
}
</style>
